
import React, { Fragment, useState, useEffect, useContext, useRef } from 'react'
import AppContext from '../../contexts/AppContext'
//import Ticker from 'react-ticker'
import { Carousel } from 'react-bootstrap'
import useToastContext from "../../hooks/useToastContext"
import { defaultBgImages, rgbaToHtml } from '../../services/banners'

const placeFilter = (items, place) => items.filter(item => item.place == place)

const findPlaceholder = (items, type) => {
    const placeholders = placeholderItems(items).filter(item => item.type == type)
    return placeholders.length > 0 ? placeholders[0] : null
}

const realItems = items => items.filter(item => !item.is_placeholder)
const placeholderItems = items => items.filter(item => item.is_placeholder)

const slidesFromBanners = (items, max, withPlaceholder) => {

    const placeholderOneRoom = findPlaceholder(items, '1-room')
    const placeholderTwoRoom = findPlaceholder(items, '2-room')

    let _items
    if(withPlaceholder){
        _items = items
    }else{
        _items = realItems(items)
    }

    var slides = []
    for(var i = 0; i < _items.length; i ++){
        var item = _items[i]
        var room = parseInt(item.type.replace('-room', ''))
        var hasAdded = false
        for(var j =0; j < slides.length; j ++){
            var slide = slides[j]
            if(slide.room < max && (slide.room + room <= max)){
                slides[j].room = slide.room + room
                slides[j].items.push(item)
                hasAdded = true
                break
            }
        }
        if(!hasAdded){
            slides.push({
                room: room,
                items: [item]
            })
        }
    }

    for(var j =0; j < slides.length; j ++){
        var slide = slides[j]
        if(slide.room < max){
            if((max - slide.room) == 1){
                if(placeholderOneRoom){
                    slides[j].room = max
                    slides[j].items.push(placeholderOneRoom)
                }
            }
            if((max - slide.room) == 2){
                if(placeholderTwoRoom){
                    slides[j].room = max
                    slides[j].items.push(placeholderTwoRoom)
                }
            }
        }
    }

    return slides
}
/*
const TextLine = ({ items, className }) => {
    className = className ? className : ''

    const { bannerServices } = useContext(AppContext)
    const addToast = useToastContext()

    const speedDefault = 5
    const [ speed, setSpeed ] = useState(speedDefault)

    const [ hasViewed, setHasViewed ] = useState(false)

    useEffect(() => {
        if(!hasViewed){
            setHasViewed(true)
            if(items.length > 0){
                setTimeout(() => bannerServices.views(items.map(item => item.id)).then(() => {}).catch(() => {}), 2500)
            }
        }
    }, [])

    if(items.length == 0) return null

    return (
        <div
            onMouseEnter={() => setSpeed(0)}
            onMouseLeave={() => setSpeed(speedDefault)}
        >
            <Ticker
                mode="smooth"
                className={className}
                speed={speed}
            >
                {({ index }) => {
                    const length = items.length
                    const item = items[index % length]
                    const text = item.title ? item.title : item.description
                    const hasLink = item.link_to ? true : false

                    return (
                        <div
                            className={'text-white text-nowrap ' + className + (hasLink ? ' cursor-pointer' : '')}
                            style={{fontSize: '18px'}}
                            onClick={e => {
                                e.preventDefault()
                                if(hasLink){
                                    if(item.id){
                                        bannerServices.click(item.id).then(res => {
                                            document.location.href = res.banner.link_to
                                        }).catch(res => {
                                            addToast({message: res.statusText, type: 'danger'})
                                        })
                                    }else{
                                        document.location.href = item.link_to
                                    }
                                }
                            }}
                        >{text}</div>
                    )
                }}
            </Ticker>
        </div>
    )
}
*/
const AdvancedBanner = ({ item }) => {
    const { bannerServices } = useContext(AppContext)
    const addToast = useToastContext()
    const [ hasViewed, setHasViewed ] = useState(false)
    const bannerRef = useRef(null)
    const [ width, setWidth ] = useState(null)

    const inViewPort = () => {
        const rect = bannerRef && bannerRef.current && bannerRef.current.getBoundingClientRect()
        return rect && rect.right > 0 && rect.left < window.innerWidth && rect.bottom > 0 && rect.top < window.innerHeight
    }

    useEffect(() => {
        if(!hasViewed && inViewPort()){
            setHasViewed(true)
            setTimeout(() => bannerServices.views([item.id]).then(() => {}).catch(() => {}), 1000)
        }
    }, [])

    useEffect(() => {
        setWidth(bannerRef.current.clientWidth)
    }, [bannerRef.current])

    const screenSize = width < 576 ? 'xs' : width >= 576 && width < 768 ? 'sm' : width >=768 && width < 992 ? 'md' : width >= 992 && width < 1200 ? 'lg' : 'xl'

    const hashCode = str => {
        var hash = 0, i, chr
        if (str.length === 0) return hash
        for (i = 0; i < str.length; i++) {
            chr   = str.charCodeAt(i)
            hash  = ((hash << 5) - hash) + chr
            hash |= 0
        }
        return hash
    }

    const image_id = item && item.options && item.options.settings && item.options.settings.image_id ? item.options.settings.image_id : null
    const backgroundColor = item && item.options && item.options.settings && item.options.settings.backgroundColor ? rgbaToHtml(item.options.settings.backgroundColor) : null

    var bgImage
    var style
    if(image_id && typeof image_id == 'string' && image_id.includes('default-')){
        bgImage = defaultBgImages.filter(image => image.id == image_id)[0].urls['2000_2000']
    }else if(image_id && typeof image_id == 'string' && image_id == 'custom-image'){
        const _image = item.images && item.images[0]
        bgImage = _image ? _image.urls['2000_2000'] : null
    }else{
        bgImage = item && item.options && item.options.bgImage
        if(!bgImage && item.images && item.images.length > 0){
            bgImage = item.images[0].urls['500_500']
        }
    }

    style = {
        backgroundPostion: '50% 50%', backgroundSize: 'cover'
    }
    if(backgroundColor) style.backgroundColor = backgroundColor
    if(bgImage) style.backgroundImage = 'url(' + bgImage + ')'

    return (
        <div className={'card advanced-card h-100'}  ref={bannerRef}>

            <div
                className="card-img-bg d-print-none"
                style={style}
            >

                {bgImage ? (
                    <img src={bgImage} className="d-none d-print-inline img-fluid w-100" />
                ) : (
                    <div className="card-img-bg no-image d-none d-print-block">
                        <FontAwesomeIcon icon={faCamera} className="text-light" />
                    </div>
                )}
            </div>
            <div className="card-body">
                {item.title && <h3 className="h4 text-truncate" title={item.title}>{item.title}</h3>}
                {item.description && <p className="mb-0 text-truncate">{item.description}</p>}
                {item.link_to &&
                    <div className="w-100">
                        <a
                            href=""
                            className="stretched-link"
                            onClick={e => {
                                e.preventDefault()
                                if(item.id){
                                    bannerServices.click(item.id).then(res => {
                                        document.location.href = res.banner.link_to
                                    }).catch(res => {
                                        addToast({message: res.statusText, type: 'danger'})
                                    })
                                }else{
                                    document.location.href = item.link_to
                                }
                            }}
                        ></a>
                    </div>
                }
            </div>

        </div>
    )
}

const Banner = ({ item, isActive, confirmLink }) => {

    const { bannerServices } = useContext(AppContext)
    const addToast = useToastContext()
    const [ hasViewed, setHasViewed ] = useState(false)
    const bannerRef = useRef(null)
    const [ width, setWidth ] = useState(null)
    const inViewPort = () => {
        const rect = bannerRef && bannerRef.current && bannerRef.current.getBoundingClientRect()
        return rect && rect.right > 0 && rect.left < window.innerWidth && rect.bottom > 0 && rect.top < window.innerHeight
    }

    useEffect(() => {
        if(isActive && ! hasViewed && inViewPort()){
            setHasViewed(true)
            setTimeout(() => bannerServices.views([item.id]).then(() => {}).catch(() => {}), 1000)
        }
    }, [isActive])

    useEffect(() => {
        setWidth(bannerRef.current.clientWidth)
    }, [bannerRef.current])

    const screenSize = width < 576 ? 'xs' : width >= 576 && width < 768 ? 'sm' : width >=768 && width < 992 ? 'md' : width >= 992 && width < 1200 ? 'lg' : 'xl'

    const Content = ({ item, confirmLink }) => {
        return (
            <div ref={bannerRef} className="h-100 px-5 py-3 d-flex flex-column justify-content-center" style={{minHeight: '250px', backgroundColor: 'rgba(0, 0, 0, 0.35)'}}>
                {item.title && <h3 className="h4">{item.title}</h3>}
                {item.description && <p className="lead mb-0">{item.description}</p>}
                {item.link_to &&
                    <div className="w-100">
                        <a
                            href=""
                            className="btn btn-primary stretched-link"
                            onClick={e => {
                                e.preventDefault()
                                if(item.id){
                                    bannerServices.click(item.id).then(res => {
                                        if(confirmLink){
                                            if(confirm('Open the link?')){
                                                document.location.href = res.banner.link_to
                                            }
                                        }else{
                                            document.location.href = res.banner.link_to
                                        }
                                    }).catch(res => {
                                        addToast({message: res.statusText, type: 'danger'})
                                    })
                                }else{
                                    if(confirmLink){
                                        if(confirm('Open the link?')){
                                            document.location.href = item.link_to
                                        }
                                    }else{
                                        document.location.href = item.link_to
                                    }
                                }
                            }}
                        >Learn more...</a>
                    </div>
                }
            </div>
        )
    }

    const hashCode = str => {
        var hash = 0, i, chr
        if (str.length === 0) return hash
        for (i = 0; i < str.length; i++) {
            chr   = str.charCodeAt(i)
            hash  = ((hash << 5) - hash) + chr
            hash |= 0
        }
        return hash
    }

    const ContentHtml = ({ item, confirmLink }) => {
        return (
            <div ref={bannerRef} className="h-100">
                <div key={hashCode(item.html)} className="h-100" dangerouslySetInnerHTML={{ __html: item.html}} />
                {item.link_to &&
                    <a href="" className="stretched-link"
                        onClick={e => {
                            e.preventDefault()
                            if(item.id){
                                bannerServices.click(item.id).then(res => {
                                    if(res.banner.link_to){
                                        if(confirmLink){
                                            if(confirm('Open the link?')){
                                                document.location.href = res.banner.link_to
                                            }
                                        }else{
                                            document.location.href = res.banner.link_to
                                        }
                                    }
                                }).catch(res => {
                                    addToast({message: res.statusText, type: 'danger'})
                                })
                            }else{
                                if(confirmLink){
                                    if(confirm('Open the link?')){
                                        document.location.href = item.link_to
                                    }
                                }else{
                                    document.location.href = item.link_to
                                }
                            }
                        }}
                    ></a>
                }
            </div>
        )
    }

    const className = item && item.options && item.options.className
    const image_id = item && item.options && item.options.settings && item.options.settings.image_id ? item.options.settings.image_id : null
    const backgroundColor = item && item.options && item.options.settings && item.options.settings.backgroundColor ? rgbaToHtml(item.options.settings.backgroundColor) : null

    var bgImage
    var style
    if(image_id && typeof image_id == 'string' && image_id.includes('default-')){
        bgImage = defaultBgImages.filter(image => image.id == image_id)[0].urls['2000_2000']
    }else if(image_id && typeof image_id == 'string' && image_id == 'custom-image'){
        const _image = item.images && item.images[0]
        bgImage = _image ? _image.urls['2000_2000'] : null
    }else{
        bgImage = item && item.options && item.options.bgImage
        if(!bgImage && item.images && item.images.length > 0 && item.images[0].urls){
            bgImage = item.images[0].urls['2000_2000']
        }
    }

    style = {}
    if(backgroundColor) style.backgroundColor = backgroundColor
    if(bgImage) style.backgroundImage = 'url(' + bgImage + ')'

    return (
        <div
            className={
                'banner h-100 d-flex flex-column justify-content-center '
                + (className ? className : backgroundColor ? '' : ' bg-white')
            }
            style={style}
        >
            {(item && item.html) ? (
                <ContentHtml item={item} confirmLink={confirmLink} />
            ) : (item && (item.title || item.description)) ? (
                <Content item={item} confirmLink={confirmLink} />
            ) : null}
        </div>
    )
}

const Slides = ({ items, max, width, withPlaceholder, confirmLink }) => {
    if((!items || realItems(items).length == 0) && !withPlaceholder) return null

    const [ activeBanner, setActiveBanner ] = useState(0)

    const slides = slidesFromBanners(items, max, withPlaceholder)
    const unit = 12 / max
    const showControls = slides.length > 1 && width > 567
    return (
        <Carousel indicators={false} controls={showControls} interval={3000} onSlide={key => setActiveBanner(key)}>
            {slides.map((slide, i) => {
                return (
                    <Carousel.Item key={i}>
                        <div className="row">
                            {slide.items.map((item, j) => {
                                const room = parseInt(item.type.replace('-room', ''))
                                const colSize = ((room * unit % 12 == 0) || room * unit > 12) ? 12 : room * unit % 12
                                const isActive = slides[activeBanner] && slides[activeBanner].items.filter(_item => _item.id == item.id).length > 0 ? true : false

                                return (
                                    <div className={'col-lg-' + colSize} key={item.id ? item.id : ('index-' + j)}>
                                        <Banner item={item} isActive={isActive} confirmLink={confirmLink} />
                                    </div>
                                )
                            })}
                        </div>
                    </Carousel.Item>
                )
            })}
        </Carousel>
    )
}

const Block = ({ categorySlug, page }) => {
    const { data, bannerServices } = useContext(AppContext)
    const { isReady } = data

    const [ loading, setLoading ] = useState([])
    const [ banners, setBanners ] = useState([])

    const loadBanners = () => {
        setLoading(true)
        return bannerServices.index({
            places: [ 'main', 'main-line-1', 'main-line-2' ],
            page: page,
            category_slug: categorySlug ? categorySlug : null
        }).then(res => {
            setBanners(res.banners) 
            setLoading(false)
        }).catch(res => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if(isReady) loadBanners()
    }, [isReady, categorySlug, page])

    const [ width, setWidth ] = useState(window.innerWidth)
    const updateDimensions = () => setWidth(window.innerWidth)
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    const maxInRow = width >= 1200 ? 3 : width >= 992 ? 2 : 1

    if(!banners || realItems(banners).length == 0) return null

    const ml1Banners = placeFilter(banners, 'main-line-1')
    const mBanners = placeFilter(banners, 'main')
    const ml2Banners = placeFilter(banners, 'main-line-2')

    return (
        <div className="bg-dark py-4 main-banner">

            <div className="container">

                {/*
                <TextLine
                    items={ml1Banners}
                    className={'ticker-line-block' + (mBanners.length > 0 || ml2Banners.length > 0 ? ' mb-4' : '')} />

                <Slides
                    items={mBanners}
                    max={maxInRow}
                    width={width}
                />

                <TextLine
                    items={ml2Banners}
                    className={'ticker-line-block' + (mBanners.length > 0 || ml1Banners.length > 0 ? ' mt-4' : '')}
                />
                */}

            </div>
        </div>
    )
}

export default Block

export { Slides, AdvancedBanner }
